export const translations = {
    'PTBR': {
        mainTitle: 'Aprenda até 10x mais rápido com IA',
        subTitle: 'A LearnArez é uma plataforma de aprendizado que utiliza inteligência artificial para personalizar o conteúdo de acordo com o seu perfil, criando sessões únicas, flashcards e testes sob medida, ajudando você a aprender de forma mais eficiente e rápida.',
        ctaButton: 'Começar Grátis',
        ctaButtonLogin: 'Entrar',
        ctaButtonRegister: 'Registrar',
        advantages: [
            {
                title: "Sessões de estudo personalizadas",
                description: "Você escolhe os temas, e a IA cria sessões de estudo únicas adaptadas às suas necessidades, otimizando seu processo de aprendizado."
            },
            {
                title: "Criação fácil de flashcards",
                description: "Crie flashcards rapidamente e de forma intuitiva, exatamente como você precisa, com a ajuda da IA."
            },
            {
                title: "Testes personalizados para você",
                description: "A IA gera testes personalizados com base nos temas que você deseja estudar e no seu nível de conhecimento atual, garantindo que você sempre aprenda de forma eficaz."
            },
            {
                title: "Organização completa dos estudos",
                description: "Tenha controle total sobre o que, quando e como estudar sem se perder em excesso de informações."
            },
            {
                title: "Aprendizado prático e objetivo",
                description: "Sem enrolação: estude exatamente o que importa, totalmente focado no seu progresso."
            },
            {
                title: "Interface limpa, simples e intuitiva",
                description: "Fácil de usar, com design bonito e feito para você focar no que realmente importa: aprender."
            },
            {
                title: "Acesso de qualquer lugar",
                description: "Estude a qualquer hora, de qualquer dispositivo, 100% online."
            },
            {
                title: "Aprenda no seu ritmo, do seu jeito",
                description: "Você escolhe os temas, define suas metas e a IA ajuda a guiar sua jornada de aprendizado."
            }
        ]
    },
    'EN': {
        mainTitle: 'Learn up to 10x faster with AI',
        subTitle: 'LearnArez is a learning platform that uses artificial intelligence to personalize content according to your profile, creating unique sessions, flashcards, and tailored tests, helping you learn more efficiently and quickly.',
        ctaButton: 'Start Free',
        ctaButtonLogin: 'Login',
        ctaButtonRegister: 'Register',
        advantages: [
            {
                title: "Personalized study sessions",
                description: "You choose the topics, and the AI creates unique study sessions tailored to your needs, optimizing your learning process."
            },
            {
                title: "Easy flashcard creation",
                description: "Create flashcards quickly and intuitively, exactly the way you need, with AI assistance."
            },
            {
                title: "Custom tests for you",
                description: "AI generates personalized tests based on the topics you want to study and your current knowledge level, ensuring you always learn effectively."
            },
            {
                title: "Complete study organization",
                description: "Have full control over what, when, and how to study without getting lost in information overload."
            },
            {
                title: "Practical and objective learning",
                description: "No fluff: study exactly what matters, fully focused on your progress."
            },
            {
                title: "Clean, simple, and intuitive interface",
                description: "Easy to use, beautifully designed, and made for you to focus on what truly matters: learning."
            },
            {
                title: "Access from anywhere",
                description: "Study anytime, from any device, 100% online."
            },
            {
                title: "Learn at your own pace, your way",
                description: "You choose the topics, set your goals, and the AI helps guide you on your learning journey."
            }
        ]
    }
}

export type LanguageKeys = keyof typeof translations;